import { Competence, Matiere } from '@teetsh/app/src/types/bo';

export function getCompetencesOfAMatiere(
  matiere?: Matiere,
  domaineName?: string,
): Competence[] {
  if (!matiere) return [];
  const filteredDomaines = (matiere.domaines || []).filter(
    d => d.nom === domaineName,
  );
  // Ici on aimerait bien filtrer par domaine si domaineName est défini, mais on a pas un mapping parfait.
  // Par exemple, "Vivant, matière, objets" doit matcher "Questionner le monde du vivant, de la matière et des objets"
  // Donc on filtre le bon domaine, mais si on a pas de résultat, on prend tous les domaines de la matière.
  const domaines = filteredDomaines.length
    ? filteredDomaines
    : matiere.domaines || [];

  return [
    ...(matiere.competences || []),
    ...domaines.reduce(
      (acc, num) => [...acc, ...[...(num.competences || [])]],
      [],
    ),
  ];
}
